import React from "react";
import ReactDOM from "react-dom";
import "./css/index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "../node_modules/leonardo-ui/dist/leonardo-ui.css";
import "../node_modules/leonardo-ui/dist/leonardo-ui.js";
import schoolList from "./hypercube/Schools";

var enigma = require("enigma.js");
var qixSchema = require("enigma.js/schemas/12.34.11.json");

var config = {
  schema: qixSchema,
  /* url: "wss://qap.ipc-global.com/app/engineData", //QAP
  appId: "9132f8da-292f-4b9b-b3ec-e714b9ecc2d2" */
  url: "wss://temp-dashboards.philasd.org/app/engineData", //QAP
  appId: "99cdf3c7-90ff-4f5f-8c12-a35af5371bdb"
  /* When ready for launch, make sure to replace all sprcalc with the proper SPR Calculator name. */
  /* Instructions for Rebuilding:
  1.) Replace all instances of sprcalc above with sprcalc
  2.) Build the project below using yarn build
  3.) Make a zip of the file with the proper name
  */
  /* url: "ws://localhost:4848/app/engineData",
  appId: "SPRCalculator_Testing.qvf" //Desktop */
};

var session = enigma.create(config);
const properties = {
  qInfo: {
    qType: "my-field-list"
  },
  qFieldListDef: {}
};

session
  .open()
  .then(function(global) {
    return global.openDoc(config.appId);
  })
  .then(function(engine) {
    //engine.createSessionObject(schoolList).then(object => object.getLayout()).then(layout => console.log('Field list:', layout)).catch( error => console.log(error))
    // Pass the Qlik's app object to the App component
    ReactDOM.render(<App engine={engine} />, document.getElementById("root"));
    serviceWorker.register();
  })
  .catch(error => {
    console.log(error);
    ReactDOM.render(
      <span>
        <h2>Unable to Load data, please contact Support</h2>
      </span>,
      document.getElementById("root")
    );
  });
/* if(!window.location.href.includes("local")){
    let href = window.location.href.split("/");
    if (href[3] !== "secure" && href[2] === "temp-dashboards.philasd.org") {
      href.splice(3, 0, "secure");
      window.location.href = href.join().replace(/,/g, "/");
    }} */
